var React = require('react');

function ScheduleLaterTimesButton (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#4287c6;}.cls-2{fill:#fff;}.cls-3{fill:none;}")),React.createElement("title",{"key":1},"later-times-button"),React.createElement("g",{"id":"Capa_2","data-name":"Capa 2","key":2},React.createElement("g",{"id":"Capa_1-2","data-name":"Capa 1"},[React.createElement("circle",{"className":"cls-1","cx":"12.5","cy":"12.5","r":"12.25","key":0}),React.createElement("path",{"className":"cls-2","d":"M12.68,14.78l4.2-4.2a.25.25,0,1,0-.36-.36l-4,4-4-4A.25.25,0,0,0,8,10.4a.25.25,0,0,0,.07.18l4.2,4.2A.25.25,0,0,0,12.68,14.78Z","key":1}),React.createElement("rect",{"className":"cls-3","width":"25","height":"25","key":2})]))]);
}

ScheduleLaterTimesButton.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = ScheduleLaterTimesButton;

ScheduleLaterTimesButton.default = ScheduleLaterTimesButton;
